import { render, staticRenderFns } from "./ViewEmployDoctor.vue?vue&type=template&id=addd457a&"
import script from "./ViewEmployDoctor.vue?vue&type=script&lang=js&"
export * from "./ViewEmployDoctor.vue?vue&type=script&lang=js&"
import style0 from "./ViewEmployDoctor.vue?vue&type=style&index=0&id=addd457a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports